import RightArrow from './RightArrow';

export default RightArrow;